import { Store } from '../../../store';
import { OverlayService } from '../../../services/overlay.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-bespoke-form-modal',
    templateUrl: './bespoke-form-modal.component.html',
    styleUrls: ['./bespoke-form-modal.component.scss']
})
export class BespokeFormModalComponent implements OnInit {

    productToView;

    constructor(
        private store: Store,
        private overlayService: OverlayService,
    ) { }

    ngOnInit(): void {
        this.productToView = this.store.selectForLocal('product');
    }

    close() {
        this.overlayService.closeAll();
    }

}
